import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useChatSession } from '~/modules';

import { IntakeDetailPageHeader } from './components/IntakeDetailPageHeader';
import { IntakeDetail } from './IntakeDetail';
import { useIntakeDetail } from './IntakeDetail.hooks';

export const IntakeDetailPage = () => {
  const { chatSession } = useIntakeDetail();
  const session = useChatSession();

  return (
    <PageLayout renderHeader={<IntakeDetailPageHeader id={session.id} status={chatSession?.status} />}>
      <IntakeDetail />
    </PageLayout>
  );
};
